import { createFileRoute } from '@tanstack/react-router'
import { ProcessDataWorkbench } from 'pages/processData/ProcessDataWorkbench'
import { processDataChartSearchSchema } from 'routes/process-data/-searchParams'

export const Route = createFileRoute('/process-data/chart/$chartID')({
  component: RouteComponent,
  validateSearch: processDataChartSearchSchema,
  staticData: {
    title: 'Process Data Chart',
    layout: {
      enableScrolling: false,
    },
  },
})

function RouteComponent() {
  const { chartID } = Route.useParams()
  const { orgId, siteId, alertId, sensorIds, start, end, mode } =
    Route.useSearch()

  return (
    <ProcessDataWorkbench
      orgId={orgId}
      siteId={siteId}
      chartId={chartID}
      alertId={alertId}
      sensorIdsParam={sensorIds}
      start={start}
      end={end}
      mode={mode}
    />
  )
}
